<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};

function resizeWidth() {
  let cw = document.documentElement.clientWidth;
  document.getElementById("app").style.width = cw + "px";
  document.documentElement.style.fontSize = cw / 10 + "px";
}
resizeWidth();
window.onresize = function () {
  resizeWidth();
};
</script>

<style>
html,
body,
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "PingFangSC-Regular", "Avenir", Helvetica, Arial, sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue